const USER_ID_KEY = 'userId';

export const userStorage = {
  set: (userId) => {
    try {
      localStorage.setItem(USER_ID_KEY, userId);
    } catch (error) {
      console.error('Failed to save userId to localStorage:', error);
    }
  },

  get: () => {
    try {
      return localStorage.getItem(USER_ID_KEY);
    } catch (error) {
      console.error('Failed to get userId from localStorage:', error);
      return null;
    }
  },

  remove: () => {
    try {
      localStorage.removeItem(USER_ID_KEY);
    } catch (error) {
      console.error('Failed to remove userId from localStorage:', error);
    }
  },

  has: () => {
    return !!userStorage.get();
  },
};
